import { StoreState } from "store";

export const getSelectedExtraProducts = (state: StoreState) => state.extraProducts.selected;
export const getExtraProducts = (state: StoreState) => state.extraProducts.extraProducts;
export const getExtraProductsFetchStatus = (state: StoreState) => state.extraProducts.fetchStatus;
export const getPreOptedAncillaries = (state: StoreState) => state.extraProducts.preOptedAncillaries;
